import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FastPayments } from '../_model/fast-payments.model';

@Injectable({
  providedIn: 'root'
})
export class FastPaymentsService {

  constructor(private _http: HttpClient) { }

  getPayment(id: string): Observable<FastPayments> {
    const url = `${environment.FAST_PAYMENTS.BASE}${environment.FAST_PAYMENTS.PAYMENTS}`;
    let params = new HttpParams();

    params = params.append('paymentCode', id);

    return this._http.get<FastPayments>(url, { params: params });
  }

  createBlikPayment$(paymentId: string, blikCode: string, system: string): Observable<void> {
    return this._http.put<void>(
      `${environment.FAST_PAYMENTS.BASE}${environment.FAST_PAYMENTS.PAYMENTS}/${system}/${paymentId}/pay/${blikCode}`,
      {}
    );
  }

  getPaymentConfirmation(id: string, system: string): Observable<FastPayments> {
    return this._http.get<FastPayments>(`${environment.FAST_PAYMENTS.BASE}${environment.FAST_PAYMENTS.PAYMENTS}/${system}/${id}`)
  }

  getPDF(id: string, system: string): Observable<any> {
    return this._http.get<FastPayments>(`${environment.FAST_PAYMENTS.BASE}${environment.FAST_PAYMENTS.PAYMENTS}/${system}${environment.FAST_PAYMENTS.PDF}/${id}`, { responseType: 'blob' as 'json' })
  }
}
